import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useDidMount } from 'rooks';
import FilterModule from '../../modules/Filter';
import TaskListModule from '../../modules/TaskList';
import TestEditorModule from '../../modules/TestEditor';
import { createTest } from '../../redux/actions';

const CreateTestPage = () => {
	const state = useSelector((state) => state);
	const dispatch = useDispatch();

	useDidMount(() => {
		dispatch(createTest(state.user.id));
	});

	return (
		state.editor?.test && (
			<>
				<FilterModule />
				<TaskListModule />
				<TestEditorModule mode="edit" />
			</>
		)
	);
};

export default CreateTestPage;
